import { AlertDefaults } from 'src/app/hickory-api';
import { deepCopy } from 'src/app/shared/model/utility';
import { AlertModelService } from '../alert-model.service';

export class AlertSenderHelper {

  static postProcess(service: AlertModelService, alert: AlertDefaults = service.alertSettings) {
    // populate required sender values from alert defaults if necessary
    alert.sender = alert.sender ?? service.alertDefaults?.sender ?? {};
    if (!alert.sender.email) alert.sender.email = service.alertDefaults?.sender?.email;
    if (!alert.sender.displayName) alert.sender.displayName = service.alertDefaults?.sender?.displayName;
    if (!alert.sender.callerId) alert.sender.callerId = service.alertDefaults?.sender?.callerId;
  }

  static preparePreview(service: AlertModelService, preview: AlertDefaults) {
    if (!preview || service.isEditingTemplate || service.isCallCenter) return;
    if (!preview.sender) preview.sender = {};
    // backfill with values from current user if necessary
    if (!preview.sender.displayName?.length) preview.sender.displayName = this.ensureDisplayName(service);
    if (!preview.sender.email?.length) preview.sender.email = this.ensureEmail(service);
    if (!preview.sender.callerId?.length) preview.sender.callerId = this.ensureCallerId(service);
  }

  static ensureDisplayName(service: AlertModelService): string {
    const senderName = service.alertSettings?.sender?.displayName;
    if (senderName) return senderName;
    return this.fallbackDisplayName(service);
  }

  static ensureEmail(service: AlertModelService): string {
    const senderEmail = service.alertSettings?.sender?.email;
    if (senderEmail) return senderEmail;
    return this.fallbackEmail(service);
  }

  static ensureCallerId(service: AlertModelService): string {
    const senderCallerId = service.alertSettings?.sender?.callerId;
    if (senderCallerId) return senderCallerId;
    return this.fallbackCallerId(service)
  }

  static fallbackDisplayName(service: AlertModelService): string {
    const name = service?.currentUser?.name; 
    let builder = ""
    if (name?.givenName?.length) builder += name?.givenName;
    if (name?.familyName?.length) builder += builder.length ? ` ${name?.familyName}` : name?.familyName;
    return builder.length ? builder : null;
  }

  static fallbackEmail(service: AlertModelService): string {
    return service?.currentUser?.contact?.emails?.find(e => e.address?.length )?.address;
  }

  static fallbackCallerId(service: AlertModelService): string {
    return service?.alertDefaults?.sender?.callerId;
  }

  static summaryText(service: AlertModelService): string {
    const senderName = service.alertSettings?.sender?.displayName;
    const senderEmail = service.alertSettings?.sender?.email;
    let summary = '';
    if (senderName?.length) summary += senderName;
    if (senderEmail?.length) {
      if (summary.length) summary += '\n';
      summary += senderEmail;
    }

    return summary;
  }

  static resetToDefaultSender(service: AlertModelService) {
    const defaultSender = service.alertTemplate?.alertSettings?.sender || {};
    service.alertSettings.sender = deepCopy(defaultSender);
  }

  static isDefaultSender(service: AlertModelService): boolean {
    const defaultSender = service.alertTemplate?.alertSettings?.sender;
    return JSON.stringify(service.alertSender || {}) === JSON.stringify(defaultSender || {});
  }
}
